import React from 'react';
import Input from '../../../components/ui/Input';

const AvailabilityToggle = ({ day, label, availability, onChange }) => {
  const handleToggleChange = (e) => {
    onChange?.('available', e?.target?.checked);
  };

  const handleFromChange = (e) => {
    onChange?.('from', e?.target?.value);
  };

  const handleUntilChange = (e) => {
    onChange?.('until', e?.target?.value);
  };

  return (
    <div className="flex items-center gap-4 py-3 px-4 border border-gray-200 rounded-lg bg-gray-50">
      <div className="w-20 text-sm font-medium text-gray-700">
        {label}
      </div>
      
      <div className="flex items-center gap-3 flex-1">
        {/* Available Toggle */}
        <div className="flex items-center gap-2">
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={availability?.available || false}
              onChange={handleToggleChange}
              className="sr-only"
            />
            <div className={`relative w-11 h-6 rounded-full transition-colors ${
              availability?.available ? 'bg-purple-600' : 'bg-gray-300'
            }`}>
              <div className={`absolute top-0.5 left-0.5 bg-white w-5 h-5 rounded-full transition-transform ${
                availability?.available ? 'transform translate-x-5' : ''
              }`}></div>
            </div>
          </label>
          <span className="text-sm text-gray-600 min-w-[60px]">Available</span>
        </div>

        {/* Time Fields */}
        {availability?.available && (
          <>
            <div className="flex items-center gap-2">
              <label className="text-sm text-gray-600 min-w-[35px]">From</label>
              <Input
                type="time"
                value={availability?.from || '09:00'}
                onChange={handleFromChange}
                className="w-24"
              />
            </div>
            
            <div className="flex items-center gap-2">
              <label className="text-sm text-gray-600 min-w-[35px]">Until</label>
              <Input
                type="time"
                value={availability?.until || '17:00'}
                onChange={handleUntilChange}
                className="w-24"
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AvailabilityToggle;